import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AssetInspectionFinancialDto } from '@proxy/register-service/assets';

@Component({
  selector: 'app-event-table',
  templateUrl: './event-table.component.html',
  styleUrls: ['./event-table.component.scss'],
})
export class EventTableComponent {
  @Input() data: AssetInspectionFinancialDto[] = [];
  @Output() viewClick = new EventEmitter<string>();

  onView(record: AssetInspectionFinancialDto) {
    this.viewClick.emit(record.inspectionId);
  }
}
